export default "__VITE_ASSET__le9QGwUK__"